<template>
  <div class="background-sec1">
    <div class="overlay-sec1"></div>

    <!-- 섹션 내부 오른쪽 사이드바 -->
    <SideFloatingBanner />

    <div class="banner-text-sec1">
      <p><strong>ICI Korea</strong> &nbsp; Recognizing Competency World-Wide</p>
    </div>
  </div>

  <section class="icik-intro">
    <div class="icik-intro__inner">
      <!-- 왼쪽: 이미지 -->
      <div class="icik-intro__image">
        <img src="@/assets/HeaderICIK.png" alt="ICIK 로고" />
      </div>

      <!-- 오른쪽: 텍스트 -->
      <div class="icik-intro__text">
        <h2 class="icik-intro__title">
          한국내부통제협회 (Internal Control Institute Korea, ICI KOREA)
        </h2>
        <p>
          한국내부통제협회는 국제내부통제협회 한국지부(ICI Korea)로서,
          내부통제, 기업지배구조, 리스크 관리, 준법감시 및 감사 분야의 전문성 강화를 위해 설립된 국내 대표 내부통제 전문단체입니다.
          내부통제 평가 강화와 리스크 대응력 제고의 중요성이 커지는 환경 속에서, 협회는 내부통제 체계 구축, 중장기 전략 수립, 전사 리스크 관리,
          전문가 교육 및 국제 전문자격 과정(CICS, CICP) 등을 통해 조직의 투명경영과 리스크 관리 수준 향상을 지원하고 있습니다.
          아울러 공공기관과 민간기업의 지속가능한 성장과 투명한 경영문화 확산을 목표로,
          검증된 방법론과 풍부한 경험을 바탕으로 회원과 함께 성장하는 신뢰받는 전문 파트너로 자리매김하고 있습니다.
        </p>
      </div>
    </div>
  </section>
  <section class="news-events-clean">
    <!-- 협회 소식 -->
    <div class="panel">
      <header class="panel__header">
        <h3 class="panel__title">협회 소식</h3>
        <a class="panel__more" @click="go({ path: '/newsmain', query: { tab: 'news' } })" aria-label="더보기">
          <i class="fa-solid fa-arrow-right"></i>
        </a>
      </header>
      <ul class="panel__list" v-for="(vo, index) in unionList" :key="index">
        <li @click="goUnionDetail(vo.unionId)">{{ vo.title }}</li>
      </ul>
    </div>

    <!-- 교육 및 주요 행사 -->
    <div class="panel">
      <header class="panel__header">
        <h3 class="panel__title">교육 및 주요 행사</h3>
        <a class="panel__more" @click="go({ path: '/newsmain', query: { tab: 'events' } })" aria-label="더보기">
          <i class="fa-solid fa-arrow-right"></i>
        </a>
      </header>
      <ul class="panel__list" v-for="(vo, index) in noticeList" :key="index">
        <li @click="goNoticeDetail(vo.noticeId)">{{ vo.title }}</li>
      </ul>
    </div>
  </section>

  <div class="cta-grid">
    <button @click="go({ path: '/archivemain', query: { tab: 'archivetree' } })" class="cta-button">
      <i class="fa-solid fa-diagram-project cta-icon"></i>
      <span>유형별 통제 매트릭스 사전</span>
    </button>

    <button @click="go({ path: '/archivemain', query: { tab: 'dictionary' } })" class="cta-button">
      <i class="fa-solid fa-book cta-icon"></i>
      <span>내부통제 용어사전</span>
    </button>

    <button @click="goFraudComic" class="cta-button">
      <span class="cta-svg-wrap">
        <img
          src="/assets/filesearch2.svg"
          alt=""
          class="cta-svg-icon cta-svg-default"
        />
        <img
          src="/assets/filesearchWhite2.svg"
          alt=""
          class="cta-svg-icon cta-svg-hover"
        />
      </span>

      <span> 부정사건 파일</span>
    </button>

    <button @click="go('/iiccmain/selfassessment/surveypublic')" class="cta-button">
      <i class="fa-solid fa-chalkboard-teacher cta-icon"></i>
      <span>ESG <br/> Governance 진단</span>
    </button>

    <button @click="go({ path: '/qnamain', query: { tab: 'faq' } })" class="cta-button">
      <i class="fa-solid fa-bell cta-icon"></i>
      <span>자주하는 질문</span>
    </button>


  </div>

  <section class="bottom-banner">
    <div v-for="(banner, idx) in bannerList" :key="banner.id || idx" class="banner-item">
      <a v-if="banner.link" :href="banner.link" target="_blank" rel="noopener noreferrer">
        <img :src="apiBaseUrl + banner.bannerImgFile1" :alt="banner.alt || `banner-${idx + 1}`" />
      </a>
      <img v-else :src="apiBaseUrl + banner.bannerImgFile1" :alt="banner.alt || `banner-${idx + 1}`" />
    </div>
  </section>



  <!-- <div class="wrapper-sec7">
    <div class="background-sec7">
      <div class="content-sec7 card-sec7">
        <h2 class="heading-sec7">Become a Member</h2>

        <p class="description-sec7">
          내부통제·거버넌스 전문가로서의 경력을 한 단계 도약시키세요.<br />
          한국내부통제협회(ICI KOREA)의 회원이 되어, 전문 역량 강화를<br />
          위한 다양한 전문 자료와 네트워크를 활용해 보십시오.
        </p>

        <p class="description-sec7">ICI KOREA 회원에게는 다음과 같은 혜택이 제공됩니다</p>

        <ul class="become-a-member-list">
          <li><i class="fa-solid fa-circle-check"></i> 내부통제 및 감사 분야의 선도 전문가와의 네트워크 구축</li>
          <li><i class="fa-solid fa-circle-check"></i> 교육 프로그램 및 실무 중심의 도구 이용</li>
          <li><i class="fa-solid fa-circle-check"></i> 최신 규제 동향과 우수사례(Best Practices)에 대한 지속적인 업데이트</li>
          <li><i class="fa-solid fa-circle-check"></i> 전문 자격 인증 및 교육을 통한 전문가로서의 인정</li>
        </ul>

        <button @click="go('/membershipmain')" class="join-btn-sec7">JOIN NOW</button>

      </div>
    </div>
  </div> -->
  <!-- <PopupImage v-model="showPopup1" :src="popupSrc1" alt="CICS 국제공인내부통제사 제1회 자격과정 교육 안내"
    storage-key="cics-popup1-skip-until" /> -->

  <!-- (두 번째 팝업이 있다면) storage-key만 다르게 -->

  <!-- PopupImage 반복 렌더링 -->
  <!-- <PopupImage v-for="(p, idx) in popupList" :key="p.id || p.storageKey || idx" v-model="p.show" :href="p.link"
    :src="apiBaseUrl + p.popupUrl" :alt="p.altText || `popup-${idx + 1}`" :storage-key="p.storageKey" /> -->

  <!-- PopupLayer만 사용 2025-12-24 위 팝업을 대채함 -->
  <PopupLayer
    :popups="popupList"
    :apiBaseUrl="apiBaseUrl"
    @close-popup="handleClosePopup"
  />


  <!-- <PopupImage v-model="showPopup2" src= 'http://192.168.0.39:8022/up_imgs/popup_file/P00004/KakaoTalk_20250929_094802507_03.jpg' alt="두 번째 팝업" storage-key="cics-popup2-skip-until" /> -->
  <!-- <PopupImage v-model="showPopup1" :src="popupSrc1" alt="두 번째 팝업" storage-key="cics-popup2-skip-until" /> -->
  <!-- <FloatingBanner :src="bannerImg1" href="https://example.com" alt="테스트 배너" :offsetTop="144" :offsetRight="10"
    :width="200" />
  <FloatingBanner :src="bannerImg2" href="https://example.com" alt="테스트 배너" :offsetTop="244" :offsetRight="10"
    :width="200" />
  <FloatingBanner :src="bannerImg3" href="https://example.com" alt="테스트 배너" :offsetTop="344" :offsetRight="10"
    :width="200" />
  <FloatingBanner :src="bannerImg2" href="https://example.com" alt="테스트 배너" :offsetTop="444" :offsetRight="10"
    :width="200" /> -->

  <!-- <div class="side-banner-wrap" :class="{ 'is-collapsed': collapsed }">
    <button class="banner-toggle" @click="collapsed = !collapsed">
      <span class="arrow" :class="{ rotated: !collapsed }" aria-hidden="true">
        &#8594;
      </span>
    </button>

    <aside id="side-banner-rail" class="banner-rail" role="complementary" aria-label="사이드 배너">
      <div class="rail-inner">
      <FloatingBanner
        v-for="(s, idx) in sideBannerList" style="border: 3px solid #3f3f3f;"
        :key="s.id || s.bannerId || idx"
        :src="apiBaseUrl + s.bannerImgFile1"
        :href="s.link || undefined"
        :alt="s.alt || `side-banner-${idx + 1}`"
        :slotHeight="92"
        bg="#1e1e1e"
        :pad="0"
        :radius="0"
        :shadow="true"
      />

      </div>
    </aside>
  </div> -->

</template>

<script setup>
// import FloatingBanner from '@/components/banner/FloatingBanner.vue';
import PopupImage from '@/components/popup/PopupImage.vue';
import { onActivated, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
// import bannerImg1 from '@/assets/mainhome.jpg'
// import bannerImg2 from '@/assets/CICPCertification.jpeg'
// import bannerImg3 from '@/assets/mainhome.jpg'
import { popupList as fetchPopupList } from '@/api/popup'
//increaseDailyVisitr
import { increaseDailyVisitr } from '@/api/user'
import {
  bannerList as fetchBannerList,
  // sideBannerList as fetcSideBanner
} from '@/api/banner'
import { noticeList as fetcNoticeList } from '@/api/notice'
import { unionList as fetchUnionList } from '@/api/union'
import SideFloatingBanner from '@/components/sidefloating/SideFloatingBanner.vue';
import PopupLayer from '@/components/PopupLayer.vue';
const router = useRouter();

// const activeTab = ref('news')

// const collapsed = ref(false)

function go(to) {
  router.push(to)
}

// const goToMembership = () => {
//   router.push('/membershipmain')
// }

const apiBaseUrl = process.env.VUE_APP_API_URL;

// 각 팝업 이미지 경로
// const popupSrc1 = new URL('@/assets/cics-popup.jpg', import.meta.url).href
// const popupSrc2 = new URL('@/assets/popup2.jpg', import.meta.url).href // 두 번째 이미지

// 각 팝업 표시 상태
const showPopup1 = ref(true)
const showPopup2 = ref(true)

const popupList = ref([])
const bannerList = ref([])
// const sideBannerList = ref([])
const noticeList = ref([])
const unionList = ref([])

const goNoticeDetail = (code) => {

  router.push({
    name: 'eventsdetail',
    query: {
      noticeId: code // ex)D00009 
    }
  })
}

const goFraudComic = () => {
  window.location.href = `${process.env.BASE_URL}fraud-comic.html`
}

const goUnionDetail = (code) => {
  router.push({
    name: 'newsdetail',
    query: {
      unionId: code // ex)D00009 
    }
  })
}

// 간단 해시
const hash = (s) => {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0
  return h.toString(36)
}

const storageKeyFor = (p) =>
  `cics-popup-${p.id ?? hash(p.popupUrl)}-skip-until` // 오늘 하루 보지 않기용

// 핵심: sessionStorage(세션 1회) 제거
const hydrateShowFlags = () => {
  const now = Date.now()
  popupList.value = popupList.value.map((raw) => {
    const storageKey = storageKeyFor(raw)
    const until = Number(localStorage.getItem(storageKey) || 0)

    return {
      ...raw,
      storageKey,
      show: now >= until,
    }
  })
}

const getPopupList = async () => {
  try {
    const param = {
      pageNo: 1,
      countPerRecord: 5,
      search: '',
      typeCd: 'all',
      status: 'PUBLISHED',
    }
    const result = await fetchPopupList(param)

    if (result?.result === 'ok') {
      popupList.value = result.data || []
      hydrateShowFlags()
    } else {
      popupList.value = []
    }
  } catch (err) {
    console.error('팝업 조회 오류:', err)
    popupList.value = []
  }
}

// PopupWindow에서 close emit 오면 show만 false로
function handleClosePopup(popup) {
  popupList.value = popupList.value.map((p) =>
    p.storageKey === popup.storageKey ? { ...p, show: false } : p
  )
}

const getBannerList = async () => {
  try {
    const param = {
      pageNo: 1,
      countPerRecord: 12,
      search: '',
      typeCd: 'all',
      status: 'PUBLISHED'
    }

    const result = await fetchBannerList(param)
    if (result?.result === 'ok') {
      // 일단 원본 그대로 세팅
      bannerList.value = result.data || []
    } else {
      bannerList.value = []
      console.warn(result?.resultMsg ?? '팝업 조회 실패')
    }
  } catch (err) {
    console.error('팝업 조회 오류:', err)
    bannerList.value = []
  }
}

// const getSideBannerList = async () => {
//   try {
//     const param = {
//       pageNo: 1,
//       countPerRecord: 4,
//       search: '',
//       typeCd: 'all',
//       status: 'PUBLISHED'
//     }

//     const result = await fetcSideBanner(param)
//     if (result?.result === 'ok') {
//       // 일단 원본 그대로 세팅
//       sideBannerList.value = result.data || []
//     } else {
//       sideBannerList.value = []
//       console.warn(result?.resultMsg ?? '팝업 조회 실패')
//     }
//   } catch (err) {
//     console.error('팝업 조회 오류:', err)
//     sideBannerList.value = []
//   }
// }

const getNoticeList = async () => {
  try {
    const param = {
      pageNo: 1,
      countPerRecord: 6,
      search: '',
      typeCd: 'all'
    }

    const result = await fetcNoticeList(param)
    if (result?.result === 'ok') {
      // 일단 원본 그대로 세팅
      noticeList.value = result.data || []
    } else {
      noticeList.value = []
      console.warn(result?.resultMsg ?? '팝업 조회 실패')
    }
  } catch (err) {
    console.error('팝업 조회 오류:', err)
    noticeList.value = []
  }
}

const getUnionList = async () => {
  try {
    const param = {
      pageNo: 1,
      countPerRecord: 6,
      search: '',
      typeCd: 'all'
    }

    const result = await fetchUnionList(param)
    if (result?.result === 'ok') {
      // 일단 원본 그대로 세팅
      unionList.value = result.data || []
    } else {
      unionList.value = []
      console.warn(result?.resultMsg ?? '팝업 조회 실패')
    }
  } catch (err) {
    console.error('팝업 조회 오류:', err)
    unionList.value = []
  }
}

const VIEW_TTL_MS = 15 * 60 * 1000

const VISIT_KEY = 'daily-visit:last'  // 하루 단위가 아니라 15분 단위 캐시

function shouldIncreaseVisit() {
  const last = Number(localStorage.getItem(VISIT_KEY) || 0)
  return Date.now() - last >= VIEW_TTL_MS
}

function markVisited() {
  localStorage.setItem(VISIT_KEY, String(Date.now()))
}


async function maybeIncreaseDailyVisit() {
  try {
    if (!shouldIncreaseVisit()) return
    // POST 호출: 방문자수 +1
    await increaseDailyVisitr()
    // 성공하면 타임스탬프 저장 (15분 동안 재호출 방지)
    markVisited()
  } catch (e) {
    console.warn('방문자수 증가 실패:', e)
    // 실패해도 재시도는 15분 뒤에 다시 이루어지도록 그대로 둠(낙관적 저장 X)
  }
}

onMounted(async () => {
  await maybeIncreaseDailyVisit()

  // ✅ 1초 후 자동 닫힘
  // setTimeout(() => {
  //   collapsed.value = true
  // }, 1000)

  const now = Date.now()

  // '오늘 하루 보지 않기' 만료 시각
  const until1 = Number(localStorage.getItem('cics-popup1-skip-until') || 0)
  const until2 = Number(localStorage.getItem('cics-popup2-skip-until') || 0)

  // 세션당 1회 노출 키
  const sess1 = 'cics-popup1-shown'
  const sess2 = 'cics-popup2-shown'

  // 팝업1: 만료되지 않았고 오늘 세션에 아직 안 띄웠다면 표시
  if (now >= until1 && !sessionStorage.getItem(sess1)) {
    showPopup1.value = true
    sessionStorage.setItem(sess1, '1')
  }

  // 팝업2: 독립적으로 동일 로직 적용
  if (now >= until2 && !sessionStorage.getItem(sess2)) {
    showPopup2.value = true
    sessionStorage.setItem(sess2, '1')
  }
  await getPopupList()
  await getBannerList()
  await getNoticeList()
  await getUnionList()
  // await getSideBannerList()

})
onMounted(getPopupList)
onActivated(getPopupList) // KeepAlive일 때 홈 복귀 시 재노출

/** 사이드 배너 헬퍼*/
// 사이드 배너 위치/크기 기본값
// const SIDE_BASE_TOP = 110    // 첫 번째 배너의 top
// const SIDE_STEP = 90
// const SIDE_DEFAULT_RIGHT = 0
// const SIDE_DEFAULT_WIDTH = 200

// const getSideOffsetTop = (s, idx) => {
//   // API에 offsetTop이 있으면 우선 사용, 없으면 일정 간격으로 세로 스택
//   return typeof s.offsetTop === 'number'
//     ? s.offsetTop
//     : SIDE_BASE_TOP + idx * SIDE_STEP
// }

// const getSideOffsetRight = (s) => {
//   // API에 offsetRight가 있으면 사용, 없으면 기본값
//   return typeof s.offsetRight === 'number'
//     ? s.offsetRight
//     : SIDE_DEFAULT_RIGHT
// }

// const getSideWidth = (s) => {
//   // API에 width가 있으면 사용, 없으면 기본값
//   return typeof s.width === 'number'
//     ? s.width
//     : SIDE_DEFAULT_WIDTH
// }

</script>

<style scoped src="./MainHome.css"></style>